var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOctagonXFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32967 1.46967C7.47032 1.32902 7.66109 1.25 7.86 1.25H16.14C16.3389 1.25 16.5297 1.32902 16.6703 1.46967L22.5303 7.32967C22.671 7.47032 22.75 7.66109 22.75 7.86V16.14C22.75 16.3389 22.671 16.5297 22.5303 16.6703L16.6703 22.5303C16.5297 22.671 16.3389 22.75 16.14 22.75H7.86C7.66109 22.75 7.47032 22.671 7.32967 22.5303L1.46967 16.6703C1.32902 16.5297 1.25 16.3389 1.25 16.14V7.86C1.25 7.66109 1.32902 7.47032 1.46967 7.32967L7.32967 1.46967ZM12 10.9393L8.99999 7.93933L7.93933 8.99999L10.9393 12L7.93933 15L8.99999 16.0607L12 13.0607L15 16.0607L16.0607 15L13.0607 12L16.0607 8.99999L15 7.93933L12 10.9393Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagonXFilled);
export default __webpack_public_path__ + "static/media/octagon-x-filled.1ef58f1831ba6e4d07e64212ad55173e.svg";
export { ForwardRef as ReactComponent };